module.exports = __webpack_public_path__ + "img/Body_feathers_DiffuseColor.ac6ea0b.png";